import React, {useEffect, useState} from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiX, FiAlertCircle} = FiIcons;
const KEY = 'rss-nsw-notice-seen';

function NoticeModal() {
  const [open, setOpen] = useState(() => {
    try { return !sessionStorage.getItem(KEY); } catch (e) { return true; }
  });

  const close = () => {
    try { sessionStorage.setItem(KEY, '1'); } catch (e) { /* ignore */ }
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') close(); };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div className="modal-backdrop" onClick={close} initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}>
          <motion.div
            className="modal-card" role="dialog" aria-modal="true" aria-label="Important notice"
            onClick={(e) => e.stopPropagation()}
            initial={{opacity: 0, y: 30, scale: 0.95}} animate={{opacity: 1, y: 0, scale: 1}} exit={{opacity: 0, y: 20, scale: 0.95}}>
            <button className="modal-x" onClick={close} aria-label="Close notice"><SafeIcon icon={FiX} /></button>
            <div className="modal-icon"><SafeIcon icon={FiAlertCircle} /></div>
            <h3>Important Notice</h3>
            <p>To report misconduct by a driving instructor, call Transport for NSW on <strong>131 500</strong>.</p>
            <button className="button button-primary modal-ok" onClick={close}>I understand</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default NoticeModal;